module.exports = __webpack_public_path__ + "img/rightIcon.eb52f0f3.svg";